<template>
    <div>
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="viewRecord" v-show="isImported  && !isDeleted"  v-b-tooltip.hover :title="$t('Drilling.DailyReports.View')"/>
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" v-show="!isImported  && !isDeleted" v-b-tooltip.hover :title="$t('Drilling.DailyReports.Edit')"/>
      <feather-icon icon="XCircleIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openCancelImportation" v-show="isImported" v-b-tooltip.hover :title="$t('Drilling.DailyReports.CancelImport')"  />
      <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" v-show="!isImported && !isDeleted" v-b-tooltip.hover :title="$t('Delete')"/>
      <feather-icon icon="RotateCcwIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openRestoreConfirm" v-show="isDeleted" v-b-tooltip.hover :title="$t('Drilling.DailyReports.Restore')"/>
    </div>
</template>

<script>
export default {
  name: 'DailyReportActionsCellRenderer',
  computed: {
    isImported() {
      return this.params.data.isImported;
    },
    isDeleted() {
      return this.params.data.isDeleted;
    }
  },
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
    },
    viewRecord () {
      this.params.context.componentParent.viewData(this.params.data);
    },
    openDeleteConfirm() {
      this.$deleteConfirmation({
        text: this.$t('Drilling.DailyReports.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },
    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.data.stagingDailyReportId);
    },
    openRestoreConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t('Restore'),
        text: this.$t('Drilling.DailyReports.ConfirmRestore'),
        accept: this.restoreRecord
      });
    },
    restoreRecord () {
      this.params.context.componentParent.restoreReport(this.params.data);
    },
    openCancelImportation() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('Drilling.DailyReports.ConfirmCancelImport'),
        accept: this.cancelImportation
      });
    },
    cancelImportation () {
      this.params.context.componentParent.cancelImportation(this.params.data);
    }
  }
}
</script>
